import React, { useMemo } from "react"
import PropTypes from "prop-types"

import { useSelector } from "react-redux"
import Spinner from "components/common/Spinner"
import styles from "../../../Calendar.module.css"
import CalendarTimeGrid from "../../CalendarTimeGrid"

const Week = ({ date }) => {
  const { loading, bookings } = useSelector((state) => state.calendar)

  const events = useMemo(() => {
    return bookings?.map((booking) => ({
      id: booking?.uuid,
      start: booking?.formatted_start_time,
      end: booking?.formatted_end_time,
      title: booking?.title,
      date: booking?.formatted_date,
      payment_status: booking?.payment_status
    }))
  }, [bookings])

  return (
    <>
      <CalendarTimeGrid type="week" date={date} events={events} />
      {loading && <Spinner className={styles.spinner} absolute />}
    </>
  )
}

Week.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired
}

export default Week
